import type { EventListItem, MarketListItem } from '@/types/market'
import { MergedStream } from './merged-stream'
import type { FilterConfig, SortConfig } from './types'
import { compareEvents, compareMarkets } from './types'

export type { SortKey } from './types'
export type { ViewMode, SortConfig, FilterConfig } from './types'
export {
	DEFAULT_SORT,
	DEFAULT_FILTERS,
	isPlatformEnabled,
	compareEvents,
	compareMarkets,
} from './types'

// Event stream (4 platforms)
export class MergedEventStream extends MergedStream<EventListItem> {
	constructor(sort: SortConfig, filters: FilterConfig = {}) {
		super(
			{
				platforms: ['kalshi', 'polymarket', 'opinionlabs', 'predictfun'],
				endpoint: 'events',
				compare: compareEvents,
			},
			sort,
			filters
		)
	}
}

// Market stream (2 platforms)
export class MergedMarketStream extends MergedStream<MarketListItem> {
	constructor(sort: SortConfig, filters: FilterConfig = {}) {
		super(
			{
				platforms: ['kalshi', 'polymarket'],
				endpoint: 'markets',
				compare: compareMarkets,
			},
			sort,
			filters
		)
	}
}
